import React from 'react';
import config from '../config.json';

const CUSTOM_PAGES = config.CUSTOM_PAGES;

const login = React.lazy(() => import('../App/layout/Authentication/login'));
const DashboardDefault = React.lazy(() => import('../template/dashboard'));

const ProductsList = React.lazy(() =>
  CUSTOM_PAGES.ProductsList ? import('../template/' + CUSTOM_PAGES.ProductsList) : import('../template/products')
);
const Product = React.lazy(() =>
  CUSTOM_PAGES.Product ? import('../template/' + CUSTOM_PAGES.Product) : import('../template/product')
);
const MediaLibrary = React.lazy(() =>
  CUSTOM_PAGES.MediaLibrary ? import('../template/' + CUSTOM_PAGES.MediaLibrary) : import('../template/media_library')
);
const MediaLibraryV2 = React.lazy(() => import('../template/media_library_v2'));
const OrdersList = React.lazy(() =>
  CUSTOM_PAGES.OrdersList ? import('../template/' + CUSTOM_PAGES.OrdersList) : import('../template/orders')
);
const Order = React.lazy(() =>
  CUSTOM_PAGES.Order ? import('../template/' + CUSTOM_PAGES.Order) : import('../template/order')
);
const TransactionsList = React.lazy(() =>
  CUSTOM_PAGES.TransactionsList
    ? import('../template/' + CUSTOM_PAGES.TransactionsList)
    : import('../template/transactions')
);
const DescriptionsList = React.lazy(() =>
  CUSTOM_PAGES.DescriptionsList
    ? import('../template/' + CUSTOM_PAGES.DescriptionsList)
    : import('../template/descriptions')
);
const Description = React.lazy(() =>
  CUSTOM_PAGES.Description ? import('../template/' + CUSTOM_PAGES.Description) : import('../template/description')
);
const CategoriesList = React.lazy(() =>
  CUSTOM_PAGES.CategoriesList ? import('../template/' + CUSTOM_PAGES.CategoriesList) : import('../template/categories')
);
const Category = React.lazy(() =>
  CUSTOM_PAGES.Category ? import('../template/' + CUSTOM_PAGES.Category) : import('../template/category')
);
const CampaignsList = React.lazy(() =>
  CUSTOM_PAGES.CampaignsList ? import('../template/' + CUSTOM_PAGES.CampaignsList) : import('../template/campaigns')
);
const Campaign = React.lazy(() =>
  CUSTOM_PAGES.Campaign ? import('../template/' + CUSTOM_PAGES.Campaign) : import('../template/campaign')
);
const BannersList = React.lazy(() =>
  CUSTOM_PAGES.BannersList ? import('../template/' + CUSTOM_PAGES.BannersList) : import('../template/banners')
);
const Banner = React.lazy(() =>
  CUSTOM_PAGES.Banner ? import('../template/' + CUSTOM_PAGES.Banner) : import('../template/banner')
);
const PricesList = React.lazy(() =>
  CUSTOM_PAGES.PricesList ? import('../template/' + CUSTOM_PAGES.PricesList) : import('../template/prices')
);
const Price = React.lazy(() =>
  CUSTOM_PAGES.Price ? import('../template/' + CUSTOM_PAGES.Price) : import('../template/price')
);
const UsersList = React.lazy(() =>
  CUSTOM_PAGES.UsersList ? import('../template/' + CUSTOM_PAGES.UsersList) : import('../template/users')
);
const User = React.lazy(() =>
  CUSTOM_PAGES.User ? import('../template/' + CUSTOM_PAGES.User) : import('../template/user')
);
const BranchesList = React.lazy(() =>
  CUSTOM_PAGES.BranchesList ? import('../template/' + CUSTOM_PAGES.BranchesList) : import('../template/branches')
);
const Branch = React.lazy(() =>
  CUSTOM_PAGES.Branch ? import('../template/' + CUSTOM_PAGES.Branch) : import('../template/branch')
);
const BranchRequestsList = React.lazy(() =>
  CUSTOM_PAGES.BranchRequestsList
    ? import('../template/' + CUSTOM_PAGES.BranchRequestsList)
    : import('../template/branch-requests')
);
const BranchRequest = React.lazy(() =>
  CUSTOM_PAGES.BranchRequest
    ? import('../template/' + CUSTOM_PAGES.BranchRequest)
    : import('../template/branch-request')
);
const ContactsList = React.lazy(() =>
  CUSTOM_PAGES.ContactsList ? import('../template/' + CUSTOM_PAGES.ContactsList) : import('../template/contacts')
);
const Contact = React.lazy(() =>
  CUSTOM_PAGES.Contact ? import('../template/' + CUSTOM_PAGES.Contact) : import('../template/contact')
);
const EventsList = React.lazy(() =>
  CUSTOM_PAGES.EventsList ? import('../template/' + CUSTOM_PAGES.EventsList) : import('../template/events')
);
const Event = React.lazy(() =>
  CUSTOM_PAGES.Event ? import('../template/' + CUSTOM_PAGES.Event) : import('../template/event')
);
const Settings = React.lazy(() =>
  CUSTOM_PAGES.Settings ? import('../template/' + CUSTOM_PAGES.Settings) : import('../template/settings')
);
const JobsList = React.lazy(() =>
  CUSTOM_PAGES.JobsList ? import('../template/' + CUSTOM_PAGES.JobsList) : import('../template/jobs')
);
const Job = React.lazy(() =>
  CUSTOM_PAGES.Job ? import('../template/' + CUSTOM_PAGES.Job) : import('../template/job')
);
const Page = React.lazy(() =>
  CUSTOM_PAGES.Page ? import('../template/' + CUSTOM_PAGES.Page) : import('../template/page')
);
const Sliders = React.lazy(() =>
  CUSTOM_PAGES.Sliders ? import('../template/' + CUSTOM_PAGES.Sliders) : import('../template/sliders')
);
const Slider = React.lazy(() =>
  CUSTOM_PAGES.Slider ? import('../template/' + CUSTOM_PAGES.Slider) : import('../template/slider')
);
const Collections = React.lazy(() =>
  CUSTOM_PAGES.Collections ? import('../template/' + CUSTOM_PAGES.Collections) : import('../template/collections')
);
const Collection = React.lazy(() =>
  CUSTOM_PAGES.Collection ? import('../template/' + CUSTOM_PAGES.Collection) : import('../template/collection')
);
const ProductCarousels = React.lazy(() =>
  CUSTOM_PAGES.product_carousels
    ? import('../template/' + CUSTOM_PAGES.product_carousels)
    : import('../template/product-carousels')
);
const ProductCarousel = React.lazy(() =>
  CUSTOM_PAGES.product_carousel
    ? import('../template/' + CUSTOM_PAGES.product_carousel)
    : import('../template/product-carousel')
);
const Faqs = React.lazy(() =>
  CUSTOM_PAGES.Faqs ? import('../template/' + CUSTOM_PAGES.Faqs) : import('../template/faqs')
);
const Faq = React.lazy(() =>
  CUSTOM_PAGES.Faq ? import('../template/' + CUSTOM_PAGES.Faq) : import('../template/faq')
);
const DiscountGroupsList = React.lazy(() =>
  CUSTOM_PAGES.DiscountGroupsList
    ? import('../template/' + CUSTOM_PAGES.DiscountGroupsList)
    : import('../template/discount-groups')
);
const DiscountGroup = React.lazy(() =>
  CUSTOM_PAGES.DiscountGroup
    ? import('../template/' + CUSTOM_PAGES.DiscountGroup)
    : import('../template/discount-group')
);
const ShiptimesList = React.lazy(() =>
  CUSTOM_PAGES.ShiptimesList ? import('../template/' + CUSTOM_PAGES.ShiptimesList) : import('../template/shiptimes')
);
const Shiptime = React.lazy(() =>
  CUSTOM_PAGES.Shiptime ? import('../template/' + CUSTOM_PAGES.Shiptime) : import('../template/shiptime')
);
const CouponsList = React.lazy(() =>
  CUSTOM_PAGES.CouponsList ? import('../template/' + CUSTOM_PAGES.CouponsList) : import('../template/coupons')
);
const Coupon = React.lazy(() =>
  CUSTOM_PAGES.Coupon ? import('../template/' + CUSTOM_PAGES.Coupon) : import('../template/coupon')
);
const PostsList = React.lazy(() =>
  CUSTOM_PAGES.PostsList ? import('../template/' + CUSTOM_PAGES.PostsList) : import('../template/posts')
);
const Post = React.lazy(() =>
  CUSTOM_PAGES.Post ? import('../template/' + CUSTOM_PAGES.Post) : import('../template/post')
);
const PackagesList = React.lazy(() =>
  CUSTOM_PAGES.PackagesList ? import('../template/' + CUSTOM_PAGES.PackagesList) : import('../template/packages')
);
const Package = React.lazy(() =>
  CUSTOM_PAGES.Package ? import('../template/' + CUSTOM_PAGES.Package) : import('../template/package')
);
const GatewaysList = React.lazy(() =>
  CUSTOM_PAGES.GatewaysList ? import('../template/' + CUSTOM_PAGES.GatewaysList) : import('../template/gateways')
);
const Gateway = React.lazy(() =>
  CUSTOM_PAGES.Gateway ? import('../template/' + CUSTOM_PAGES.Gateway) : import('../template/gateway')
);
const AdminsList = React.lazy(() => import('../template/admins'));
const Admin = React.lazy(() => import('../template/admin'));
const Profile = React.lazy(() => import('../template/profile'));
const Permissions = React.lazy(() => import('../template/permissions'));

export const loginRoute = [{ path: '/login', exact: true, name: 'Login', component: login, auth: false }];

export const routes = [
  { path: '/dashboard', exact: true, name: 'Dashboard', component: DashboardDefault, auth: true },

  { path: '/products', exact: true, name: 'Products', component: ProductsList, auth: true },
  { path: '/products/add', exact: true, name: 'Add Product', component: Product, auth: true },
  { path: '/products/update/:id', exact: true, name: 'Update Product', component: Product, auth: true },

  { path: '/media_library_v2', exact: true, name: 'چندرسانه', component: MediaLibraryV2, auth: true },
  { path: '/media_library', exact: true, name: 'Media Librray', component: MediaLibrary, auth: true },

  { path: '/orders', exact: true, name: 'Orders', component: OrdersList, auth: true },
  { path: '/order/:id', exact: true, name: 'Order', component: Order, auth: true },
  { path: '/transactions', exact: true, name: 'Transactions', component: TransactionsList, auth: true },

  { path: '/descriptions', exact: true, name: 'Descriptions', component: DescriptionsList, auth: true },
  { path: '/descriptions/add', exact: true, name: 'Add Description', component: Description, auth: true },
  { path: '/descriptions/update/:id', exact: true, name: 'Update Description', component: Description, auth: true },

  { path: '/categories', exact: true, name: 'Categories', component: CategoriesList, auth: true },
  { path: '/categories/update/:id', exact: true, name: 'Update Category', component: Category, auth: true },

  { path: '/campaigns', exact: true, name: 'Campaigns', component: CampaignsList, auth: true },
  { path: '/campaigns/add', exact: true, name: 'Add Campaign', component: Campaign, auth: true },
  { path: '/campaigns/update/:id', exact: true, name: 'Update Campaign', component: Campaign, auth: true },

  { path: '/banners', exact: true, name: 'Banners', component: BannersList, auth: true },
  { path: '/banners/add', exact: true, name: 'Add Banner', component: Banner, auth: true },
  { path: '/banners/update/:id', exact: true, name: 'Update Banner', component: Banner, auth: true },

  { path: '/prices', exact: true, name: 'Prices', component: PricesList, auth: true },
  { path: '/prices/add', exact: true, name: 'Add Price', component: Price, auth: true },
  { path: '/prices/update/:id', exact: true, name: 'Update Price', component: Price, auth: true },

  { path: '/users', exact: true, name: 'Users', component: UsersList, auth: true },
  { path: '/users/add', exact: true, name: 'Add User', component: User, auth: true },
  { path: '/users/update/:id', exact: true, name: 'Update User', component: User, auth: true },

  { path: '/admins', exact: true, name: 'Admins', component: AdminsList, auth: true },
  { path: '/admins/add', exact: true, name: 'Add Admin', component: Admin, auth: true },
  { path: '/admins/update/:id', exact: true, name: 'Update Admin', component: Admin, auth: true },
  { path: '/permissions', exact: true, name: 'Permissions', component: Permissions, auth: true },
  { path: '/profile', exact: true, name: 'Profile', component: Profile, auth: true },

  { path: '/branches', exact: true, name: 'Branches', component: BranchesList, auth: true },
  { path: '/branches/add', exact: true, name: 'Add Branch', component: Branch, auth: true },
  { path: '/branches/update/:id', exact: true, name: 'Update Branch', component: Branch, auth: true },

  { path: '/branch-requests', exact: true, name: 'Branch Requests', component: BranchRequestsList, auth: true },
  { path: '/branch-request/:id', exact: true, name: 'Branch Request', component: BranchRequest, auth: true },

  { path: '/contacts', exact: true, name: 'Contacts', component: ContactsList, auth: true },
  { path: '/contact/:id', exact: true, name: 'Contact', component: Contact, auth: true },

  { path: '/events', exact: true, name: 'Events', component: EventsList, auth: true },
  { path: '/events/add', exact: true, name: 'Add Event', component: Event, auth: true },
  { path: '/events/update/:id', exact: true, name: 'Update Event', component: Event, auth: true },

  { path: '/settings', exact: true, name: 'Settings', component: Settings, auth: true },

  { path: '/jobs', exact: true, name: 'Jobs', component: JobsList, auth: true },
  { path: '/job/:id', exact: true, name: 'job', component: Job, auth: true },

  { path: '/page/:id', exact: true, name: 'Page', component: Page, auth: true },

  { path: '/sliders', exact: true, name: 'Sliders', component: Sliders, auth: true },
  { path: '/sliders/add', exact: true, name: 'Add Slider', component: Slider, auth: true },
  { path: '/sliders/update/:id', exact: true, name: 'Update Slider', component: Slider, auth: true },

  { path: '/collections', exact: true, name: 'Collections', component: Collections, auth: true },
  { path: '/collections/add', exact: true, name: 'Add Collection', component: Collection, auth: true },
  { path: '/collections/update/:id', exact: true, name: 'Update Collection', component: Collection, auth: true },

  { path: '/product-carousels', exact: true, name: 'Product Carousels', component: ProductCarousels, auth: true },
  { path: '/product-carousels/add', exact: true, name: 'Add Product Carousel', component: ProductCarousel, auth: true },
  {
    path: '/product-carousels/update/:id',
    exact: true,
    name: 'Update Product Carousel',
    component: ProductCarousel,
    auth: true,
  },

  { path: '/faqs', exact: true, name: 'Faqs', component: Faqs, auth: true },
  { path: '/faqs/add', exact: true, name: 'Add Faq', component: Faq, auth: true },
  { path: '/faqs/update/:id', exact: true, name: 'Update Faq', component: Faq, auth: true },

  { path: '/discount-groups', exact: true, name: 'Discount Groups', component: DiscountGroupsList, auth: true },
  { path: '/discount-groups/add', exact: true, name: 'Add Discount Group', component: DiscountGroup, auth: true },
  { path: '/discount-groups/update/:id', exact: true, name: 'Update Collection', component: DiscountGroup, auth: true },

  { path: '/shipping-times', exact: true, name: 'Shipping times', component: ShiptimesList, auth: true },
  { path: '/shipping-times/add', exact: true, name: 'Add Shipping time', component: Shiptime, auth: true },
  { path: '/shipping-times/update/:id', exact: true, name: 'Update Shipping time', component: Shiptime, auth: true },

  { path: '/coupons', exact: true, name: 'Coupons', component: CouponsList, auth: true },
  { path: '/coupons/add', exact: true, name: 'Add Coupon', component: Coupon, auth: true },
  { path: '/coupons/update/:id', exact: true, name: 'Update Coupon', component: Coupon, auth: true },

  { path: '/posts', exact: true, name: 'Posts', component: PostsList, auth: true },
  { path: '/posts/add', exact: true, name: 'Add Post', component: Post, auth: true },
  { path: '/posts/update/:id', exact: true, name: 'Update Post', component: Post, auth: true },
  { path: '/posts/categories', exact: true, name: 'Posts Categories', component: CategoriesList, auth: true },
  { path: '/posts/categories/update/:id', exact: true, name: 'Update Posts Category', component: Category, auth: true },

  { path: '/packages', exact: true, name: 'Packages', component: PackagesList, auth: true },
  { path: '/packages/add', exact: true, name: 'Add Package', component: Package, auth: true },
  { path: '/packages/update/:id', exact: true, name: 'Update Package', component: Package, auth: true },

  { path: '/gateways', exact: true, name: 'Gateway times', component: GatewaysList, auth: true },
  { path: '/gateways/add', exact: true, name: 'Add Gateway time', component: Gateway, auth: true },
  { path: '/gateways/update/:id', exact: true, name: 'Update Gateway time', component: Gateway, auth: true },
];
export const panelRoutes = {
  DASHBOARD: {
    path: '/dashboard',
    title: 'خانه',
    exact: true,
    name: 'Dashboard',
    component: DashboardDefault,
  },
  LOGIN: {
    path: '/login',
    title: 'ورود',
  },
};
